import { createSlice } from '@reduxjs/toolkit';

const initialState = { isAuthenticated: null, isLoading: false };

const authSlice = createSlice({
  name: 'isAuthenticated',
  initialState,
  reducers: {
    setAuthentication(state, action) {
      const isAuthenticated = action.payload;
      return {
        ...state,
        isLoading: false,
        isAuthenticated,
      };
    },
    getAuthentication(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
  },
});

export const { setAuthentication, getAuthentication } = authSlice.actions;

export default authSlice.reducer;
